import {Injectable} from '@angular/core';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {ConfigService} from './config.service';
import { isBrowser } from 'angular2-universal';

declare var $: any;

@Injectable()
export class UtilsService {

    constructor(private config: ConfigService, private router: Router){}

    currentYear(){
        return new Date().getFullYear();
    }
    
    dateNowPlusDays(days){
        return new Date(new Date().getTime() + 24*60*60*1000 * days);
    }

    isMobile(){
        if (isBrowser) {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
                return true;
            return false;
        }
    }
    
    toLocale(language: string){
        let countryLangs = {
            fr: 'FR', 
            en: 'US'
        }
        return language+'_'+countryLangs[language];
    }

    getElementPosition(element: string, plus: number,  plus_xs: number){
        if($(window).width()<=576)
            plus = plus_xs;
        return $(element).offset().top + plus;
    }

    loadScripts(scripts, targetElement) {
        for(let scr of scripts){
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = scr;
            targetElement.appendChild(s);
        }
    }

    scroll(target, plus) {
        let scrollTo = target.getBoundingClientRect().top + plus;
        $('html, body').animate({
            scrollTop: scrollTo
        }, 1200);
    }

    scrollToClass(className, plus) {
        this.scroll($("."+className)[0], plus);
    }

    lLink(target: string, currentLanguage: string){
        if(!this.isSquashed(currentLanguage)){
            if(target!='')
                target = currentLanguage + '/' + target;
            else
                target = currentLanguage;
        }
        this.router.navigateByUrl(target);
    }

    lNavigate(target: string, language: string, route: ActivatedRoute, queryParams?:any){
        let params = {}; 
        if(queryParams)
            params = queryParams;
        if(route!=null)
            params['relativeTo'] = route;
        if(!this.isSquashed(language)) {
            if(target.startsWith('/')){
                target = target.replace(/^\//,"");
                language = '/'+language;
            }
            if(target!=''){
                let tree = [language];
                tree = tree.concat(target.split('/'));
                this.router.navigate(tree, params);
            }
            else
                this.router.navigate([language], params);
            // target = currentLanguage + sep + target;
        }
        else {
            let tree = [language];
            tree = tree.concat(target.split('/'));
            this.router.navigate(tree, params);
        }
            
    }

    queryParamsParser(params: Params, paramName: string): Object[] {
        let res: Object[] = [];
        if(params[paramName]){
            let filterObjects = params[paramName].split('>'); 
            filterObjects.forEach(fObj => {
                let typeValue = fObj.split('~');
                if(typeValue.length == 2){
                    let type = typeValue[0];
                    let value = typeValue[1];
                    res.push(JSON.parse('{"'+type+'": "'+value+'"}'));
                }
            });    
        }
        return res; 
    }
    
    filtersToEsFilters(filters: Object[], fieldSuffix: string): Object[] {
        let esFilters: Object[] = [];
        filters.forEach(f => {
            let esFilter: string  = '{"term": {"'+Object.keys(f)[0]+fieldSuffix+'": "'+f[Object.keys(f)[0]]+'"}}';
            esFilters.push(JSON.parse(esFilter));
        });
        return esFilters;
    }

    isInFilters(esFilters: any[], type: string, value: string): boolean {
        let res = false;
        esFilters.forEach(esf => {
            if(esf.term[type+'.raw'] == value){
                //console.log('+',esf.term[type], value);
                res = true;
            }
        });
        return res;
    }

    formatInHtml(str, tag){
        // if no markup around content
        if(str.indexOf(/[^<].+[^>]/)==-1)
            str = '<'+tag+'>' + str + '</'+tag+'>';
        return str;
    }

    removeQueryParam(queryParamString: string, type: string, value: string): string {
        type = type.replace(/\.raw/, ""); 
        let re = new RegExp('>?'+type+'~'+value, "gi");
        queryParamString = queryParamString.replace(re, ""); 
        queryParamString = queryParamString.replace(/^>/, "");
        return queryParamString;
    }

    appendQueryParam(queryParamString: string, type: string, value: string): string {
        if(!queryParamString)
            queryParamString = type+'~'+value;
        else 
            queryParamString += '>'+type+'~'+value;
        return queryParamString;
    }

    isSquashed(currentLanguage: string): boolean {
        //console.log(this.config.PREFERRED_LANGUAGE_SQUASH, currentLanguage, this.config.PREFERRED_LANGUAGE)
        if(this.config.data.APP.LANGUAGES.SQUASH && currentLanguage == this.config.data.APP.LANGUAGES.PREFERRED) {
            return true;
        }
        return false;
    }

    clearLgParamFromUrl(url: string): string {
        let cleared = url.replace(/lg=[a-z][a-z]/, "");
        cleared = cleared.replace(/\?$/, "");
        return cleared;
    }

    getUrlByRoute(router: Router){
        if(router.routerState.root.children[0]){
            return router.routerState.root.children[0].snapshot.url;
        }
        return null;
    }

    getLanguageByUrl(url: string): string {
        let match = url.match(/^\/([a-z][a-z])\//);
        if(match)
            return match[1];
        match = url.match(/^\/([a-z][a-z])$/);
        if(match)
            return match[1];
        return null;
    }

    // getLanguageByRoute(router: Router){
    //     if(router.routerState.root.children[0]){
    //         return router.routerState.root.children[0].snapshot.params['lg'];
    //     }
    //     return null;
    // }

    getLanguageAgnosticUrl(currentUrl: string): string {
        // 1. /en (root)
        let re = /^\/[a-z][a-z]\/?$/;
        if(currentUrl.match(re))
            return currentUrl.replace(re, "");
        // 2. /en/page
        re = /^\/[a-z][a-z]\//;
        if(currentUrl.match(re))
            return currentUrl.replace(re, "/");
        // No language initially
        return currentUrl.replace(/\/$/, "");
    }

    cleanImageName(str) {
        str = this.removeAccents(str);
        str = str.toLowerCase().replace(/[^a-z0-9]+/g,"-");
        // restore extension
        str = str.replace(/-(.{3})$/g,".$1");
        return str;
    }

    removeAccents(str) {
        let accents    = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        let strLen = str.length;
        let i, x;
        for (i = 0; i < strLen; i++) {
            if ((x = accents.indexOf(str[i])) != -1) {
                str[i] = accentsOut[x];
            }
        }
        return str.join('');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/utils.service.ts